import { render, staticRenderFns } from "./BannerTextItem.vue?vue&type=template&id=98f10a80&scoped=true"
import script from "./BannerTextItem.vue?vue&type=script&lang=js"
export * from "./BannerTextItem.vue?vue&type=script&lang=js"
import style0 from "./BannerTextItem.vue?vue&type=style&index=0&id=98f10a80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f10a80",
  null
  
)

export default component.exports